<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingRoerend">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseRoerend" aria-expanded="false" aria-controls="collapseRoerend">
                Roerende zaken
            </button>
        </h2>
        <div id="collapseRoerend" class="accordion-collapse collapse" aria-labelledby="headingRoerend"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Bij roerende zaken zoals kunst, antiek, voertuigen en sieraden dient bij schenking de waarde in het
                economische verkeer bepaald te worden. In geval van schenking binnen familiesfeer zonder bewijs van
                waarde kunnen discussies ontstaan bij controle. Bij objecten met een substantiële waarde (bijv. kunst
                met beleggingskarakter) is een onafhankelijke taxatie aan te bevelen.
                <div class="space20"></div>
                Belastingheffing kan ook ontstaan
                bij gebruiksrechten of symbolische verkoop (bijvoorbeeld een auto “voor een euro”).
            </div>
        </div>
    </div>
</div>

